<i18n src="@/locales/modules/EmployeeTranslate.json"></i18n>

<template>
	<div>
		<vs-popup class="holamundo" :title="`${$t('ResetPassword')} - ${localData.name}`" :active.sync="isPopupActiveLocal">
			<form autocomplete="off" ref="formPassword" class="__form-password">
				<div class="w-full">
					<div class="vx-col w-full relative">
						<label for class="vs-input--label">
							{{ $t("InputNewPassWord") }}
							<span class="text-danger">*</span>:
						</label>
						<vs-input
							:type="type['password']"
							size="large"
							ref="password"
							v-validate="'min:6|max:20'"
							:placeholder="$t('InputNewPassWord')"
							:data-vv-as="$t('InputNewPassWord')"
							name="password"
							v-model="localData.password"
							class="w-full"
						/>
						<i @click="visiblePassword('password')" :class="['nucleo visible-password text-2xl', type['password'] === 'password' ? 'nucleo-cmviewvisible' : 'nucleo-cmviewdisable']"></i>
						<span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first("password") }}</span>
					</div>

					<div class="vx-col w-full mt-5 ">
						<label for class="vs-input--label">
							{{ $t("ConfirmNewPassword") }}
							<span class="text-danger">*</span>:
						</label>
						<vs-input
							:type="type['confirm']"
							size="large"
							v-validate="'min:6|confirmed:password'"
							:data-vv-as="$t('ConfirmNewPassword')"
							:placeholder="$t('ConfirmNewPassword')"
							name="confirm_password"
							v-model="localData.confirmPassword"
							class="w-full"
						/>
						<i @click="visiblePassword('confirm')" :class="['nucleo visible-password text-2xl', type['confirm'] === 'password' ? 'nucleo-cmviewvisible' : 'nucleo-cmviewdisable']"></i>
						<span class="text-danger text-sm" v-show="errors.has('confirm_password')">{{ errors.first("confirm_password") }}</span>
					</div>
				</div>
				<div class="vx-row w-full">
					<div class="vx-col w-full">
						<div class="flex flex-wrap items-center sm:justify-center">
							<vs-button class="w-full sm:w-1/3 sm:max-w-xs mt-4 font-bold" @click.prevent="submitResetPassword">{{ $t("Actions.Save") }}</vs-button>
						</div>
					</div>
				</div>
			</form>
		</vs-popup>
	</div>
</template>

<script>
export default {
	name: "EmployeeResetPasswordDialog",
	props: {
		popupActive: {
			type: Boolean,
			default: false
		},
		value: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			type: {
				password: "password",
				confirm: "password"
			}
		};
	},

	methods: {
		submitResetPassword() {
			this.$emit("submitResetPassword");
		},
		visiblePassword(ref) {
			this.type[ref] = this.type[ref] === "password" ? "text" : "password";
		}
	},
	computed: {
		localData: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		isPopupActiveLocal: {
			get() {
				return this.popupActive;
			},
			set(val) {
				if (!val) {
					this.$refs.formPassword.reset();
					this.$emit("closePopup");
				}
			}
		}
	}
};
</script>
<style lang="scss">
.__form-password {
	.visible-password {
		float: right;
		margin-top: -4%;
		margin-right: 2%;
		transform: translateY(-50%);
		cursor: pointer;
	}
}
</style>
